import type { VuiComponent } from '../core'
import type { BreadcrumbsItemProps } from './breadcrumbs.types'

import { omitThemingProps, useStyleConfig, vui } from '../core'
import T from '../t'
import { cs } from '../utils'
import { useBreadcrumbsContext } from './context'

/** A Breadcrumb item. */
export const BreadcrumbsItem = vui<'div', BreadcrumbsItemProps>((props, ref) => {
  const { className, children, ...rest } = omitThemingProps(props)

  const parentContext = useBreadcrumbsContext()
  const styles = useStyleConfig('Breadcrumbs', parentContext)

  return (
    <T
      variant="navigation"
      size={parentContext.size}
      alignItems="center"
      className={cs('vui-breadcrumbs-item', className)}
      ref={ref}
      {...styles.item}
      {...rest}
    >
      {children}
    </T>
  )
}) as VuiComponent<'div', BreadcrumbsItemProps>

BreadcrumbsItem.displayName = 'BreadcrumbsItem'

export default BreadcrumbsItem
